<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/M4cRTY/tc-custom/9781439674369.jpg?1704586019265" alt="This image is the cover for the book Jazz Age Chicago"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jazz Age Chicago
      </h1>
      <p class="bookDescription body article font2">
        <p>When people imagine 1920s Chicago, they usually (and justifiably) think of Al Capone, speakeasies, gang wars, flappers and flivvers. Yet this narrative overlooks the crucial role the Windy City played in the modernization of America. The city's incredible ethnic variety and massive building boom gave it unparalleled creative space, as design trends from Art Deco skyscrapers to streamlined household appliances reflected Chicago's unmistakable style. The emergence of mass media in the 1920s helped make professional sports a national obsession, even as Chicago radio stations were inventing the sitcom and the soap opera. Join Joseph Gustaitis as he chases the beat of America's Jazz Age back to its jazz capital.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Gustaitis
      </h2>
      
      <p class="authorDescription body article">Joseph Gustaitis is a Chicago-based freelance writer and editor. He received his AB from Dartmouth College and his MA and PhD in history from Columbia University. He is the author of many popular history magazine articles. After working as an editor at <I>Collier's Year Book</I>, he became the humanities editor for <I>Collier's Encyclopedia</I>. He has also worked in television and won an Emmy Award for writing for ABC-TV's <I>FYI</I> program. His previous books are <I>Chicago in 50 Objects, Chicago's Greatest Year, 1893: The White City and the Birth of a Modern Metropolis</I> and <I>Chicago Transformed: World War I and the Windy City</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13996868